import React, { Component } from "react";
import { Table, Icon, Divider, Alert, Button, Input, Switch, Modal } from "antd";
import axios from "axios";
import "./TarefasPage.css";
import moment from "moment-timezone";
import TarefaForm from '../components/TarefaForm';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class TarefasPage extends Component {
  state = {
    tarefas: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    pessoas: [],
    nomePessoa: "",
    paginaPes: 1,
    limitePes: 10,
    totalPes: 0,
  };

  // este é invocado quando o camponente termina de carregar
  // after show
  componentDidMount() {
    this.getTarefas();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    // console.log({ total, pagina, limite, ultimaPagina })
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getTarefas)
    }
  }




  getTarefas = () => {
    this.setState({ carregando: true });

    const { busca, pagina, limite } = this.state;

    axios
      .get('/tarefas', {
        params: {
          page: pagina,
          limite: limite,
          titulo: busca,
        }
      })
      .then(response => {
        const { data, meta } = response.data;
        this.setState({
          tarefas: data,
          carregando: false,
          mensagemErro: '',
          total: meta.total,
          pagina: meta.current_page,
          limite: Number(meta.per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
          mensagemErro: "Não foi possível obter as tarefas."
        });
      });

  };

  onEditarClick = tarefa => {
    this.setState({ carregando: true });

    axios.get(`/tarefas/${tarefa.id}`)
      .then(response => {
        const { data } = response;
        this.setState({
          formVisivel: true,
          tarefaSelecionada: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.warn(error);
        this.setState({
          carregando: false,
          mensagemErro: 'Não foi possível consultar a tarefa selecionada.'
        })
      })
  };

  onExcluirClick = tarefa => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a terefa #${tarefa.id}`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });

        axios.delete(`/tarefas/${tarefa.id}`)
          .then(response => {
            const { tarefas, total } = this.state;
            const tarefaIndex = tarefas.findIndex(tar => tar.id === tarefa.id)
            tarefas.splice(tarefaIndex, 1);
            this.setState({
              tarefas: tarefas.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.warn(error);
            this.setState({
              carregando: false,
              mensagemErro: 'Não foi possível excluir esta tarefa.'
            })
          })
      }
    })
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      tarefaSelecionada: {}
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onSalvarClick = (tarefa) => {
    this.setState({
      salvando: true
    })

    let request;
    if (tarefa.id) {
      //editar
      request = axios.put(`/tarefas/${tarefa.id}`, tarefa);
    } else {
      // cadastrar
      request = axios.post(`/tarefas`, tarefa)
    }

    request
      .then(response => {
        this.getTarefas();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
      })
      .catch(error => {
        console.warn(error);
        this.setState({
          salvando: false
        })
        Modal.error({
          title: 'Erro Inesperado',
          content: 'Não foi possível salvar a tarefa.',
          okText: 'OK',
        })
      })
  }

  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getTarefas);
  };

  onAtivaChange = (tarefa, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/tarefas/${tarefa.id}/ativa`)
    } else {
      request = axios.delete(`/tarefas/${tarefa.id}/ativa`)
    }

    request.then(response => {
      tarefa.ativa = ativar;
      this.setState({
        tarefas: this.state.tarefas.concat([]),
        carregando: false
      })

    }).catch(error => {
      console.warn(error);
      this.setState({
        mensagemErro: "Não foi possível ativar esta tarefa.",
        carregando: false
      })
    })
  };

  onTabelaChange = (pagination => {
    console.log(pagination);
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getTarefas)
  })


  renderAtiva = (ativa, tarefa) => {
    return (
      <Switch
        checkedChildren="Ativa"
        unCheckedChildren="Inativa"
        checked={ativa}
        onChange={ativar => this.onAtivaChange(tarefa, ativar)}
      />
    );
    return ativa ? "Ativa" : "Inativa";
  };

  renderData = (data, tarefa) => {
    const dataMoment = moment(data);
    return (
      <span title={dataMoment.format('DD [de] MMMM [de] YYYY [às] HH:mm')}>
        {dataMoment.fromNow(true)}
      </span>
    )
  }

  renderAcoes = (text, tarefa) => {
    return (
      <ButtonGroup size="small">
        <Button type="primary" onClick={() => this.onEditarClick(tarefa)}>
          Editar
        </Button>

        <Button type="danger" onClick={() => this.onExcluirClick(tarefa)}>
          Excluir
        </Button>
      </ButtonGroup>
    );
  };

  render() {
    const { tarefas, carregando, mensagemErro, formVisivel, salvando, 
            tarefaSelecionada, total, pagina, limite, 
            pessoas, totalPes, paginaPes, limitePes, nomePessoa } = this.state;

    return (
      <div>
        <h2>Tarefas { nomePessoa }</h2>

        {mensagemErro ? <Alert message={mensagemErro} type="error" /> : null}

        <div className="tarefasPageFiltro">
          <Button
            type="primary"
            onClick={this.onAdicionarClick}
            className="tarefasPageFiltro-adicionar"
          >
            Adicionar
          </Button>

          <Search
            placeholder="Buscar por Título"
            onSearch={this.onBuscar}
            enterButton
            className="tarefasPageFiltro-busca"
          />

          <TarefaForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            tarefaSelecionada={tarefaSelecionada}
          />
        </div>

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={tarefas}
          scroll={{ x: 600 }}
          rowKey={(tarefa => tarefa.id)}
        >
          <Column key="id" dataIndex="id" title="#" />
          <Column key="titulo" dataIndex="titulo" title="Título" />
          <Column
            key="data"
            dataIndex="data"
            title="Criada há"
            render={this.renderData} />
          <Column
            key="ativa"
            dataIndex="ativa"
            title="Ativa"
            render={this.renderAtiva}
          />
          <Column
            key="acoes"
            title="Ações"
            render={this.renderAcoes}
          />
        </Table>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TarefasPage.js